import React from 'react';
import PropTypes from 'prop-types';

import IconOk from '../../../../../ui/components/IconOk';
import Container from '../../component/Container';

import styles from './index.scss';

const FeaturesAndBenefits = ({ data, header, needSeparateLine }) => (
    <Container extendClass={needSeparateLine ? styles.separateLine : ''}>
        <div name="fnb" />
        <div className={styles.headerWrapper}>
            <h2 className={styles.header}>{header}</h2>
        </div>
        <div className={styles.content}>
            {data.map((feature, i) => (
                <div className={styles.featureItems} key={i}>
                    <IconOk />
                    <div className={styles.sectionContent}>
                        <h3 className={styles.heading}>{feature.name}</h3>
                        {feature.featureItems.map((item, j) => (
                            <div className={styles.feature} key={j}>
                                <div
                                    className={styles.featureName}
                                    dangerouslySetInnerHTML={{ __html: item.title }}
                                ></div>
                                <div
                                    className={styles.featureDescription}
                                    dangerouslySetInnerHTML={{ __html: item.text }}
                                ></div>
                            </div>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    </Container>
);

FeaturesAndBenefits.propTypes = {
    data: PropTypes.array.isRequired,
    header: PropTypes.string.isRequired,
    needSeparateLine: PropTypes.bool,
};

export default FeaturesAndBenefits;
